<template>
    <div>
      <div class="v-center">
          <img
          class="mr-3 pointer"
          src="~@/assets/images/icons/arrow-back.svg"
          width="25px"
          alt=""
          @click="goBack"
        />
        <h3>Go back</h3>
        </div>
        <div :class="showtwoContainers ? 'tenant-invite-container' : 'h-center'">
    <div class="tenant-invite py-3">
      <h2>Edit Company Details</h2>
            <div  v-if="showWfCheckBox" :class="['approval-container', { 'show-bg': workflowApprovalFlag }]">
        <div class="v-center">
          <checkbox
            :checked="workflowApprovalFlag"
            @change="updateApprovalFlag"
          />
          <h4 class="main-label">Use Approval Workflow</h4>
        </div>
        <p class="sub-label">
          Enable this to require approval before tenant activation
        </p>
      </div>
      <div class="tenant-invite--form mt-3 s">
        <h3>Company Admin Details</h3>
        <div class="grid-2">
          <div data-validation="FirstName" class="input-group imp my-2">
            <label>Enter First Name</label>
            <input
            :style="disabledStyle"
            :disabled="true"
              v-model="firstName"
              placeholder="Enter your First Name"
              type="text"
            />
          </div>
          <div data-validation="LastName" class="input-group my-2 imp">
            <label>Enter Last Name</label>
            <input
            :style="disabledStyle"
            :disabled="true"
              v-model="lastName"
              placeholder="Enter your Last Name"
              type="text"
            />
          </div>
        </div>
        <div data-validation="Email" class="input-group imp my-2">
            <label>Enter Email ID</label>
            <input :style="disabledStyle" :disabled="true" v-model="email" placeholder="Enter Email ID" type="text" />
        </div>
        <h3 class="my-3">Company detail</h3>
        <div class="grid-2">
          <div data-validation="CompanyGstNumber" class="input-group imp my-2">
            <label>Enter Company GST Number</label>
            <input
            :style="disabledStyle"
             :disabled="true"
              v-model="GSTIN"
              placeholder="Enter Company GST Number"
              type="text"
            />
          </div>
          <div data-validation="CompanyPanNumber" class="input-group imp my-2">
            <label>Enter Company PAN Number</label>
            <input
            :disabled="true"
            :style="disabledStyle"
              v-model="PAN"
              placeholder="Enter Company PAN Number"
              type="text"
            />
          </div>
        </div>
        <div :class="isBeaconAdmin ? 'grid-2':''">
        <div data-validation="CompanyName" class="input-group imp my-2">
          <label>Enter Company Name</label>
          <input
          :style="!isBeaconAdmin ? disabledStyle : null"
             :disabled="!isBeaconAdmin ? true : false"
            v-model="companyName"
            placeholder="Enter Company Name"
            type="text"
          />
        </div>
        <div v-if="isBeaconAdmin" class="input-group imp my-2">
        <label class="key">Tenant Type:</label>
        <select v-model="tenant_type">
          <option v-for="item in roles" :value="item.key" :key="item.key">{{ item.value }}</option>
        </select>
      </div>
      </div>
        <div class="grid-2">
          <div data-validation="CompanyEmail" class="input-group imp my-2">
            <label>Enter Company Email</label>
            <input v-model="companyEmail" placeholder="Enter Company Email" type="text" />
          </div>
          <div data-validation="CompanyPhoneNumber" class="input-group imp my-2">
            <label>Enter Company Phone Number</label>
            <input
              v-model="companyPhone"
              placeholder="Enter Company Phone Number"
              type="text"
            />
          </div>
        </div>
        <div class="grid-2">
          <div data-validation="Latitude" class="input-group my-2 imp">
          <label>Company Location latitude</label>
      <input
        v-model.number="latitude"
        placeholder="Company Location latitude"
        type="number"
      />
        </div>
        <div data-validation="Longitude" class="input-group my-2 imp">
          <label>Company Location longitude</label>
      <input
        v-model.number="longitude"
        placeholder="Company Location longitude"
        type="number"
      />
        </div>
          <div  class="input-group my-2">
            <label>Company Description</label>
            <textarea
              v-model="description"
              placeholder="Additional Notes "
              type="text"
            />
          </div>
          <div  class="input-group my-2 imp">
          <label>Industry Vertical</label>
          <input :disabled="true" v-model="selectedIndustry" :style="disabledStyle">
        </div>
      </div>
      <div class="grid-2">
        <div data-validation="Address" class="input-group my-2">
          <label>{{isBeaconAdmin ? 'Enter URL': 'URL' }}</label>
          <input
            placeholder="Enter URL "
            type="text"
            v-model="companyUrl"
            :disabled="!isBeaconAdmin"
          />
        </div>
        <div class="input-group my-2" v-if="isBeaconAdmin">
          <label>Upload Image</label>
          <input type="file" accept="image/jpeg, image/png, image/jpg" @change=uploadImage>
        </div>
        </div>

    <!-- <h3 class="my-3">Tiered Pricing</h3>
    <div class="procurement-card">
  <h3>Procurement Details</h3>
  <div class="details-row">
    <div class="detail-box">
      <div class="icon blue"></div>
      <div class="detail-box-label">
        <p class="label">Lead Time</p>
        <p class="value">15 days</p>
      </div>
    </div>

    <div class="detail-box">
      <div class="icon purple"></div>
      <div class="detail-box-label">
        <p class="label">Minimum Order Qty</p>
        <p class="value">100 units</p>
      </div>
    </div>
  </div>
</div>
  <div class="tiered-pricing-container">
  <table class="pricing-table">
    <thead>
      <tr>
        <th>Min Qty</th>
        <th>Max Qty</th>
        <th>Price per Unit</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1</td>
        <td>50</td>
        <td>₹150</td>
      </tr>
      <tr>
        <td>51</td>
        <td>200</td>
        <td>₹140</td>
      </tr>
      <tr>
        <td>201</td>
        <td>999999</td>
        <td>₹130</td>
      </tr>
    </tbody>
  </table>
      </div> -->
          <vendor-material-pricing
          v-if="showvendorMaterials"
      ref="vendor-material-pricing"
      :materials="materialsData"
      :disabled-style="disabledStyle"
    />
        <div class="flex-end">
          <button @click="updateTenantDetails" :disabled="disableSaveButton" class="btn">Save Changes</button>
        </div>
      </div>
    </div>
    <div class="wf-container">
  <workflow-instance-edit-panel
    v-if="wfInstanceId"
    ref="WorkflowDetailsPanel"
    :wfInstanceId="wfInstanceId"
    :feature="config.CORE_FEATURES.TENANT"
    @afterWFaction="fetchMaterialLinks"
    @goBack="goBackFromWorkflowDetails"
    @finishWorkflow="finishWorkflow"
    @reOpenworkflow="reopenColabWf"
    @workflowCancelled="rejectWf"
  >
  </workflow-instance-edit-panel>
  <workflow-starting-stp-selection
  v-if="!wfInstanceId && workflowApprovalFlag "
:startStages="wf.startStages"
:selectedStartingStep="selectedStartingStep"
:templateId="wf.templateId"
:templateVersionId="wf.templateVersionId"
:wfTypeName="wf.typeName"
:selectedUserGroup="selectedUserGroup"
:feature="'tenant-invite'"
@selectStartingStep="addSelectedStep"
@removeSelection="()=>selectedStartingStep=null"
/>
    </div>
    </div>
  </div>
  </template>

<script>
import InviteTenantValidation from '@/helper/formValidation/inviteTenant'
import { GetAllTenantsListDataForBeaconAdmin, GetTenantDetails, updateTenantDetails, generateS3SubmittingUrl, updateTenantCompanyAssciation, getStartigStepsForInviteTenantWf, reInitianteVendorWF, GetAllTenantsListData, getMaterialDefualtVendor } from '@/api'
import { alert, success } from '@/plugins/notification'
import Loader from '@/plugins/loader'
import { mapGetters } from 'vuex'
// import CustomDropdown from '../common/customDropdown.vue'
import VendorMaterialPricing from '../tenant/vendorMaterialPricing.vue'
import WorkflowInstanceEditPanel from '@/views/FORM/workflowInstanceEditPanel.vue'
import config from '@/config'
import { formatedMaterialData, transformMaterials } from './inviteTenantHelper'
import Checkbox from '../common/checkbox.vue'
import WorkflowStartingStpSelection from '../form/workflowStartingStpSelection.vue'

export default {
  components: { VendorMaterialPricing, WorkflowInstanceEditPanel, Checkbox, WorkflowStartingStpSelection },
  name: 'InviteTenant',
  props: {
    collaborator: Boolean
  },
  async mounted () {
    this.loadTenantData()
  },
  data () {
    return {
      disableSaveButton: false,
      tenant_type: null,
      roles: [{ key: 1, value: 'Admin' }, { key: 2, value: 'Collaborator' }],
      tenantId: null,
      firstName: '',
      lastName: '',
      email: '',
      companyName: '',
      PAN: '',
      GSTIN: '',
      companyPhone: '',
      companyEmail: '',
      description: null,
      companyLocation: '',
      disabledStyle: {
        backgroundColor: '#f0f0f0',
        color: '#a0a0a0'
      },
      companyUrl: null,
      companyLogo: null,
      latitude: null,
      longitude: null,
      selectedIndustry: null,
      selectedAction: null,
      materialsData: null,
      wfInstanceId: null,
      config: config,
      workflowApprovalFlag: false,
      wf: {
        startStages: [],
        typeName: ''
      },
      selectedStartingStep: null,
      selectedUserGroup: [],
      wfStateName: null
    }
  },
  computed: {
    ...mapGetters(['isBeaconAdmin', 'openTenantId', 'user']),
    showWfCheckBox () {
      return !this.isBeaconAdmin && !this.wfInstanceId
    },
    showtwoContainers () {
      if (this.wfInstanceId) {
        return true
      } else if (!this.wfInstanceId && this.workflowApprovalFlag) {
        return true
      }
      return false
    },
    showvendorMaterials () {
      return ((this.materialsData !== null && this.wfInstanceId && this.wfStateName !== config.WORKFLOW_STATE_NAMES.REJECTED) || (!this.wfInstanceId && this.workflowApprovalFlag))
    }
  },
  methods: {
    loadTenantData () {
      const loader = new Loader()
      loader.show()
      this.tenantId = this.$route.params.tenantId
      GetTenantDetails(this.tenantId, this.isBeaconAdmin, this.openTenantId)
        .then(res => {
          // this  has to moved
          this.wfInstanceId = res.core_tenants[0].associated_tenants_by_target_tenant_id?.[0].approval_workflow_instance_id
          this.firstName = res.core_tenants[0].tenant_users[0].associated_user.first_name
          this.lastName = res.core_tenants[0].tenant_users[0].associated_user.last_name
          this.email = res.core_tenants[0].tenant_users[0].associated_user.email
          this.companyName = res.core_tenants[0].company_name
          this.PAN = res.core_tenants[0].PAN
          this.GSTIN = res.core_tenants[0].GSTIN
          this.companyLocation = res.core_tenants[0].company_location

          this.tenant_type = res.core_tenants[0].tenant_type
          this.companyLogo = res.core_tenants[0].company_logo_blob_key
          this.companyUrl = res.core_tenants[0].company_url
          let companyLocation = null
          // if the user is a beacon admin, we fetch the details from core_tenants directly
          // otherwise, we fetch the details from tenant_company_association
          loader.hide()
          if (this.isBeaconAdmin) {
            companyLocation = res.core_tenants[0].company_location
            this.description = res.core_tenants[0].company_description
            this.companyEmail = res.core_tenants[0].company_email
            this.companyPhone = res.core_tenants[0].company_phone ?? ''
            this.selectedIndustry = res.core_tenants[0].industry_vertical_value.name
          } else {
            this.materialsData = formatedMaterialData(res.core_tenants[0]?.associated_tenants_by_target_tenant_id?.[0].vendor_materials)
            companyLocation = res.core_tenants[0]?.associated_tenants_by_target_tenant_id?.[0].company_location
            this.description = res.core_tenants[0]?.associated_tenants_by_target_tenant_id?.[0].company_description
            this.companyEmail = res.core_tenants[0]?.associated_tenants_by_target_tenant_id?.[0].company_email
            this.companyPhone = res.core_tenants[0]?.associated_tenants_by_target_tenant_id?.[0].company_phone ?? ''
            this.selectedIndustry = res.core_tenants[0]?.associated_tenants_by_target_tenant_id?.[0].industry_vertical_value.name
            this.wfStateName = res.core_tenants[0]?.associated_tenants_by_target_tenant_id?.[0]?.workflow_instance?.state_value?.name
          }
          const locationArray = companyLocation ? companyLocation.replace(/[()]/g, '').split(',') : null
          this.latitude = !locationArray ? '' : locationArray[0]
          this.longitude = !locationArray ? '' : locationArray[1]
          if (!this.isBeaconAdmin && !this.wfInstanceId) {
            this.getWfStartStages()
          }
        })
        .catch(() => {
          loader.hide()
        })
    },
    resetForm () {
      this.companyPhone = ''
      this.companyEmail = ''
      this.description = null
      this.companyUrl = null
      this.companyLogo = null
      this.$refs['vendor-material-pricing'] && this.$refs['vendor-material-pricing'].resetForm()
    },
    async updateTenantDetails () {
      if (this.disableSaveButton) return
      this.disableSaveButton = true
      const materialsData = this.$refs['vendor-material-pricing']?.materialsTierdPricingData ?? undefined
      const tempbody = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        companyName: this.companyName,
        PAN: this.PAN,
        GSTIN: this.GSTIN,
        companyPhone: this.companyPhone,
        companyEmail: this.companyEmail,
        description: this.description,
        industryVertical: this.selectedIndustry,
        latitude: this.latitude,
        longitude: this.longitude,
        approval_workflow: this.wfInstanceId ?? this.workflowApprovalFlag,
        materials: this.wfInstanceId || this.workflowApprovalFlag ? materialsData : []
      }
      const loader = new Loader()
      if (InviteTenantValidation(tempbody)) {
        loader.show()
        let body = {} // body for core_tenants
        if (this.isBeaconAdmin) {
          body = {
            company_email: this.companyEmail,
            company_url: this.companyUrl,
            company_logo_blob_key: this.companyLogo,
            company_location: `(${this.latitude}, ${this.longitude})`,
            company_phone: this.companyPhone,
            company_description: this.description,
            tenant_type: this.tenant_type
          }
        } else {
          const { materialsToInsert, pricingTierUpdates, materialsToDelete, newPricingTiers, pricingTierDelete, vendorMaterialUpdates } = transformMaterials({ targetTenantId: this.tenantId, materials: materialsData, wfInstanceId: this.wfInstanceId })
          body = {
            payload: {
              company_phone: this.companyPhone,
              company_description: this.description,
              company_location: `(${this.latitude}, ${this.longitude})`,
              company_email: this.companyEmail
            },
            materialsToInsert,
            pricingTierUpdates,
            materialsToDelete,
            newPricingTiers,
            pricingTierDelete,
            vendorMaterialUpdates

          }
        }
        const materialIds = []
        if (body.materialsToInsert?.length > 0) {
          const vendorMaterialData = await getMaterialDefualtVendor(body.materialsToInsert.map(item => item.material_id))
          console.log(vendorMaterialData)
          for (const material of vendorMaterialData.core_material_master) {
          // this is for checking the givrn material vendor has
            if (!material.material_default_vendor) {
              materialIds.push(material.id)
            }
          }
        }

        try {
          if (this.isBeaconAdmin) {
            await updateTenantDetails(this.tenantId, body, this.isBeaconAdmin)
          } else {
            await updateTenantCompanyAssciation({ id: this.tenantId, updateDefaultVendor: materialIds.length > 0, materialIds, ...body }, this.isBeaconAdmin)
          }
          if (!this.wfInstanceId && this.workflowApprovalFlag && !this.isBeaconAdmin) {
            await this.reInitianteColabWF(materialsData, this.selectedStartingStep.id)
            this.loadTenantData()
          }
          loader.hide()
          success('Successfully updated the details')
          if (this.isBeaconAdmin) {
            this.getAllTenantList()
          } else if (!this.wfInstanceId) {
            this.getAllTenantList()
          }
          this.$router.go(-1)
        } catch (err) {
          loader.hide()
          alert(err?.message ?? 'There was an error, updating the tenant. Please try again')
        } finally {
          loader.hide()
          this.disableSaveButton = false
        }
        // updateTenantDetails(this.tenantId, body, this.isBeaconAdmin).then(res => {
        //   success('Successfully updated the details')
        //   this.resetForm()
        //   this.getAllTenantList()
        //   this.$router.go(-1)
        // }).catch((err) => {
        //   alert(err?.message ?? 'There was an error, updating the tenant. Please try again')
        // }).finally(() => {
        //   loader.hide()
        // })
      }
      this.disableSaveButton = false
    },
    goBack () {
      this.$router.go(-1)
    },
    getAllTenantList () {
      if (this.isBeaconAdmin) {
        GetAllTenantsListDataForBeaconAdmin().then((res) => {
          this.$store.commit('setTenentList', res?.core_tenants)
        })
      } else {
        GetAllTenantsListData(this.user.userId, this.user.tenantId).then(
          (res) => {
            this.$store.commit('setChildTenantList', res?.child_tenants)
          }
        )
      }
    },
    uploadImage (e) {
      const file = e.target.files[0]
      const fileReader = new FileReader()
      fileReader.readAsDataURL(file)
      fileReader.onload = async (e) => {
        const { url } = await generateS3SubmittingUrl({
          tenantId: this.openTenantId,
          feature: 'metaData',
          featureId: 0,
          fileName: file.name
        })
        await fetch(url, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        const blobkey = url.split('?')[0].split('.com/').pop()
        this.companyLogo = blobkey
      }
    },
    handleActionSelect () {

    },
    fetchMaterialLinks () {

    },
    goBackFromWorkflowDetails () {

    },
    finishWorkflow () {
      this.getAllTenantList()
      this.$refs.WorkflowDetailsPanel.updateWorkflowMaterial(true)
    },
    updateApprovalFlag (value) {
      this.workflowApprovalFlag = value
    },
    getWfStartStages () {
      getStartigStepsForInviteTenantWf().then((res) => {
        this.wf = {
          startStages: res.workflow_templates[0]?.workflow_versions[0]?.workflow_stages,
          typeName: res.workflow_templates[0]?.type_value?.name,
          templateId: res.workflow_templates[0]?.id,
          templateVersionId: res.workflow_templates[0]?.workflow_versions[0]?.id
        }
        if (this.wf.startStages?.length === 1) {
          this.selectedStartingStep = this.wf.startStages[0]
        }
      })
    },
    addSelectedStep () {

    },
    reInitianteColabWF (materialsData = [], startingStepId) {
      const reInitianteWFData = {
        target_tenant_id: this.tenantId,
        step_id: startingStepId,
        materials: materialsData.map((material) => ({
          material_id: material.material_id,
          moq: material.moq,
          lead_time: material.lead_time,
          tier_pricing: material.tier_pricing.map(pricing => ({
            min_qty: pricing.min_qty,
            max_qty: pricing.max_qty,
            unit_cost: pricing.unit_cost
          }))
        }))
      }
      return reInitianteVendorWF(reInitianteWFData)
    },
    async reopenColabWf () {
      try {
        const startingStepData = await getStartigStepsForInviteTenantWf()
        const materialData = []
        const startStepId = startingStepData.workflow_templates[0]?.workflow_versions[0]?.workflow_stages[0]?.id
        await this.reInitianteColabWF(materialData, startStepId)
        this.$refs.WorkflowDetailsPanel.getWorkFlowStepData()
      } catch (err) {
        this.$refs.WorkflowDetailsPanel.getWorkFlowStepData()
        console.log(err)
        alert(err)
      }
    },
    rejectWf () {
      this.wfStateName = config.WORKFLOW_STATE_NAMES.REJECTED
      this.getAllTenantList()
    }

  }
}
</script>

  <style lang="scss" scoped>
  .tenant-invite {
    &-container{
      display :grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem; /* adjust as per your current spacing, e.g., 16px or 1.5rem */
      align-items: center;
    }
    max-width: 800px;
    // margin: auto;
    font-size:12px;
    & h2, & h3 {
      font-weight: 500;
    }
    & h3 {
      font-size: var(--text-l);
    }
    &--form {
      background: var(--white);
      padding: 20px;
      & > div {
        margin: auto;
      }
    }
    & .grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem; /* adjust as per your current spacing, e.g., 16px or 1.5rem */
  align-items: start;
}
& .procurement-card {
  background: #fff;
  padding: 18px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  margin-bottom: 20px;
  // font-family: $font;

  h3 {
    margin: 0 0 15px;
    font-size: .9rem;
    font-weight: 500;
  }

  .details-row {
    display: flex;
justify-content: space-between;

    .detail-box {
      display: flex;
      align-items: center;
      gap: 10px;
      &-label{
        display: flex;
        flex-direction: column;
        gap: 5px;

      }

      .icon {
        width: 35px;
        height: 35px;
        border-radius: 10px;

        &.blue { background: #e6f2ff; }
        &.purple { background: #f0e6ff; }
      }

      .label {
        margin: 0;
        color: #777;
        font-size: var(--text-s);
      }

      .value {
        margin: 0;
        color: #333;
        font-size: var(--text-base);
        font-weight: 700;
      }
    }
  }
}
& .tiered-pricing-container{
  padding: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  margin-bottom: 1.5rem;
   .pricing-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;

    th, td {
      padding: 8px;
      font-size: var(--text-m);
    }

    th {
    background: #f5f5f5;
    font-size: .9rem;
    font-weight: 500;
    text-align: left;
    }

    td {
      border-bottom: 1px solid #eee;
    }
  }
  & .add-price-tier-btn{
    width: 100%;
    padding: 6px;
    border: none;
    background: transparent;
    color: #374151;
    font-size: var(--text-s);
    cursor: pointer;
    transition: background-color 0.3s;
    border-radius: 5px;
    border: 1px solid #d1d5db;
    margin-top:16px;
     grid-column: span 3;
    &:hover{
      background-color: var(--brand-light-color);
      border-color: var(--brand-color);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      transform: translateY(-1px);
      transition: transform 0.2s ease;
    }

  }
}
 & .approval-container {
    transition: width 1s cubic-bezier(0.4, 0, 0.2, 1);
    margin-top: 1.5rem;
    padding: 1rem;
    margin: 20px;
    border-radius: 5px;
    border: 1px solid #d1d5db;
    & .sub-label {
      margin-top: 0.5rem;
      font-size: 0.8rem;
      font-weight: 400;
      color: #374151;
    }
    & .main-label {
      margin-left: 10px;
      font-weight: 400;
    }
  }
  & .show-bg {
    border: 1px solid var(--brand-color);
    background-color: var(--brand-light-color);
  }
  }
  .wf {
    &-container{
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-top: 1.5rem;
      font-size: var(--text-s);
      align-self: baseline;
      max-width: 500px;
      margin-top:32px;

       & .submit{
         width: 100%;
    padding: 6px;
    border: none;
    background: transparent;;
    font-size: 1em;
    cursor: pointer;
    transition: background-color 0.3s;
    border-radius: 5px;
    border: 1px solid #d1d5db;
    background-color: var(--brand-light-color);
    border-color: var(--brand-color);
    font-weight: 300;
    // color: var(--white);
    &:hover{
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      transform: translateY(-1px);
      transition: transform 0.2s ease;
    }

      }
      & .cancel{
        border:1px solid #d1d5db;
        background: transparent;
        padding: 6px;
        border-radius: 5px;
        // color: var(--brand-color);
        font-weight: 300;
       font-size: 1em;
        cursor: pointer;
           &:hover{
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      transform: translateY(-1px);
      transition: transform 0.2s ease;
    }
      }
    }
    &-currentstep-data{
      padding: 1rem;
      border: 1px solid #d1d5db6e;;
      border-radius: 8px;
      & .item-box{
        display : grid;
        grid-gap: 5px;
        grid-template-columns: 5fr 1fr 8fr;
        align-items: center;
        & .current-step-name{
          font-size:1em;
          font-weight: 400;
          color: blue
        }
        & label{
          font-size:1em;
          font-weight: 300;
          color: #504e4e;
        }
      }
      & hr{
        border-color: #f5f5f554;
        margin-bottom: 1em;
      }
    }
    &-action{
      padding: 1rem;
      border: 1px solid rgba(209, 213, 219, 0.431372549);
      border-radius: 10px;
    }
   }
  .input-group {
  input, select ,textarea {
    font-size: 1.11em;
  }
}
@media (max-width: 480px) {
  .tenant-invite-container{
grid-template-columns: 1fr;

& .wf-container{
  width: 100%;
}
  }
  .tenant-invite {
  width:fit-content;
}
.tenant-invite {
  width:fit-content;
}
}

/* Tablets (portrait and small tablets: 481px - 767px) */
@media (min-width: 481px) and (max-width: 767px) {
   .tenant-invite-container{
grid-template-columns: 1fr;

& .wf-container{
  width: 100%;
}
  }
}

/* Tablets (standard: 768px - 1024px) */
@media (min-width: 768px) and (max-width: 1024px) {
  .tenant-invite {
  width:500px;
  max-width:600px;
}
}

/* Laptops (1025px - 1280px) */
@media (min-width: 1025px)  {
.tenant-invite {
  width:700px;
  max-width:700px;
}
}
/* Desktops (1281px - 1600px) */
@media (min-width: 1281px)  {
.tenant-invite {
  width:800px;
  max-width:800px;
}
}
@media (min-width: 1601px) {
   .tenant-invite-container {
    display: flex;
    flex-direction: row;
    gap: 1rem; /* adjust as per your current spacing, e.g., 16px or 1.5rem */
    align-items: center;
    justify-content: center;
    & .wf-container{
      width: 500px;
    }
   }
   .tenant-invite {
  width:800px;
  max-width:800px;
}
}
  </style>
